module.exports = __webpack_public_path__ + "img/lighting_off.7a7fc788.svg";